module.exports = __webpack_public_path__ + "img/eres_8_steps_en.206be607.jpg";